module.exports = __webpack_public_path__ + "img/IMG_6749.86c041f8.jpg";